import * as yup from "yup";
import _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useQueryClient } from "react-query";

import NofitcationSuccess from "../notifications/agent-created.notification";
import NotificationError from "../notifications/agent-error.notification";
import { useUpdateAgent } from "../../../../../../../services/microservice/admin/agents/use-agents-admin";
import { useAgentsAdminContext } from "../../../../providers/agents-admin.provider";

export interface IFormValue {
  name: string | undefined;
  email: string | undefined;
  password: string | undefined;
  phoneNumber: string | undefined;
  role?: any;
  active?: IActive | undefined;
  sponsor?: any;
}

interface IActive {
  name: string;
  value: boolean;
}

const formatData = (params: IFormValue): any => {
  const { name, email, password, phoneNumber, role, sponsor } = params;
  const data = {};
  _.set(data, "name", name);
  _.set(data, "email", email);
  _.set(data, "password", password);
  _.set(data, "phone_number", phoneNumber);
  _.set(data, "roles", role?._id);
  _.set(data, "sponsor", sponsor?.id);
  return data as any;
};

const useAgentEditFormUtil = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { sponsor } = useAgentsAdminContext();
  const { mutateAsync: UpdateUser, isLoading } = useUpdateAgent();
  const queryClient = useQueryClient();

  const validationSchema = yup.object().shape({
    name: yup.string().required(" Requerido"),
    password: yup
      .string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .matches(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])([A-Za-z\d]|[^\w\s]){8,}$/,
        "La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial",
      ),
    email: yup
      .string()
      .email("Debes ingresar un correo electrónico válido")
      .required(" Requerido"),
    phoneNumber: yup
      .string()
      .matches(/^\d+$/, "El número de teléfono solo puede contener dígitos")
      .test(
        "len",
        "El número de teléfono debe tener exactamente 10 dígitos",
        (val) => val?.length === 10,
      )
      .required(" Requerido"),
    role: yup
      .object()
      .shape({
        name: yup.string(),
        description: yup.string(),
        idSystem: yup.string(),
      })
      .required(" Requerido"),
    sponsor: yup
      .object()
      .shape({
        name: yup.string(),
        idSystem: yup.string(),
        dobleAuth: yup.boolean(),
        isActive: yup.boolean(),
      })
      .optional(),
  });

  const submitForm = async (values: IFormValue) => {
    const data = formatData(values);
    const form = {
      id: id,
      data,
    };
    UpdateUser(form)
      .then(() => {
        toast.success(<NofitcationSuccess />);
        navigate(`/${sponsor}/admin/agents`);
      })
      .catch(() => toast.error(<NotificationError />))
      .finally(() => {
        queryClient.invalidateQueries(["agents/list"]);
      });
  };

  return { validationSchema, submitForm, isLoading };
};

export default useAgentEditFormUtil;
